<template>
  <v-card >
      <v-simple-table dense>
        <template v-slot:default>
          <thead class="primary">
            <tr>
              <th class="text-left white--text text-h6">
                {{ $t('sparkPro.listTitle')}}
              </th>
              <th class="text-left white--text text-h6">
                {{ $t('sparkPro.basic')}}
              </th>
              <th class="text-left white--text text-h6">
                {{ $t('sparkPro.pro')}}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="feature in $t('sparkPro.features')">
              <tr :key="feature.title">
                <td class="primary--text no-bottom subtitle-1">
                  {{ feature.title }}
                </td>
                <td class="no-bottom"></td>
                <td class="no-bottom"></td>
              </tr>
              <tr
                v-for="item in feature.features"
                :key="item.description"
              >
                <td>{{ item.description }}</td>
                <td>
                  <div class="d-flex justify-center">
                    <v-icon v-if="!item.onlyProFeature">mdi-check</v-icon>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-center">
                    <v-icon>mdi-check</v-icon>
                  </div>
                </td>
              </tr>

            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.no-bottom{
  border-bottom: none !important;
}
</style>
